/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Teaserdocument2Inputs */

const en_coinvestments_teaserdocument2 = /** @type {(inputs: Coinvestments_Teaserdocument2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaser Document`)
};

/**
* | output |
* | --- |
* | "Teaser Document" |
*
* @param {Coinvestments_Teaserdocument2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_teaserdocument2 = /** @type {((inputs?: Coinvestments_Teaserdocument2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Teaserdocument2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_teaserdocument2(inputs)
});
export { coinvestments_teaserdocument2 as "coInvestments_teaserDocument" }